// Lightweight analytics seam. track() pushes to window.dataLayer, so any
// tag/GTM/product-analytics layer can be attached later without touching pages.

export const EVENTS = {
    DECODER_LANDING_VIEW: "decoder_landing_view",
    DECODER_STARTED: "decoder_started",
    QUESTION_ANSWERED: "question_answered",
    DECODER_COMPLETED: "decoder_completed",
    RESULT_VIEWED: "result_viewed",
    RESULT_SHARED: "result_shared",
    DECODE_CHART_CLICKED: "decode_chart_clicked",
};

export function track(event, props = {}) {
    const payload = { event, ts: Date.now(), ...props };
    if (typeof window !== "undefined") {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(payload);
        if (process.env.NODE_ENV !== "production") {
            console.debug("[sacredspace:analytics]", payload);
        }
    }
    return payload;
}
